export function calculateTimeRemaining(endDate) {
  const now = new Date();
  const targetDate = new Date(endDate);
  const difference = targetDate - now;

  if (difference <= 1) {
    // timerInterval && clearInterval(timerInterval);
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((difference % (1000 * 60)) / 1000);

  return { days, hours, minutes, seconds };
}

export const makeString = (timeRemaining, short = true) => {
  let string = '';
  string += timeRemaining.days > 0 ? `${timeRemaining.days}${short ? 'd' : ' days'} ` : '';
  string += timeRemaining.hours > 0 ? `${timeRemaining.hours}${short ? 'h' : ' hours'} ` : '';
  string += timeRemaining.minutes > 0 ? `${timeRemaining.minutes}${short ? 'm': ' minutes'} ` : '';
  string += `${timeRemaining.seconds}${short ? 's' : ' seconds'}`;
  return string;
};

export const makeStringWithoutLetters = (timeRemaining) => {
  let string = '';
  string += timeRemaining.days > 0 ? `${timeRemaining.days}:`: '';
  string += timeRemaining.hours > 0 ? `${timeRemaining.hours}:` : '';
  string += timeRemaining.minutes > 0 ? `${timeRemaining.minutes}:` : '';
  string += `${timeRemaining.seconds}`;
  return string;
};